import styled from 'styled-components';

export const ConditionalIconButton = styled.button`
	display: inline-flex;
	align-items: center;
	appearance: none;
	border: 0;
	padding: 0.125rem 0.3125rem;
	border-radius: var(--mantine-radius-sm);
	background-color: var(--mantine-color-gray-2);
	color: var(--mantine-color-gray-9);
	cursor: pointer;
	line-height: 1;

	&:hover {
		background-color: var(--mantine-color-gray-3);
	}
`;

export const ConditionalMenuLabel = styled.p`
	margin: 0;
	padding: 0.375rem 0.5rem;
	color: var(--mantine-color-gray-9);
	font-size: 0.75rem;
	line-height: 1.125rem;
`;

export const ConditionalMenuItem = styled.button`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 0.5rem;
	width: 100%;
	appearance: none;
	border: 0;
	padding: 0.375rem 0.5rem;
	border-radius: var(--mantine-radius-sm);
	background: none;
	color: var(--mantine-color-text);
	font-size: 0.8125rem;
	line-height: 1.21875rem;
	text-align: left;
	cursor: pointer;

	&:hover {
		background-color: var(--mantine-color-gray-0);
	}
`;

export const ConditionalMenuFooter = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 0.5rem;
	margin-top: 0.25rem;
	padding: 0.5rem;
	border-top: 1px solid var(--mantine-color-gray-4);
	color: var(--mantine-color-text);
	font-size: 0.8125rem;
	line-height: 1.21875rem;
`;

export const ConditionalMenuSection = styled.div`
	padding: 0.5rem;

	.mantine-InputWrapper-root {
		margin: 0;
	}

	input {
		height: 2rem;
		min-height: 2rem;
		margin-top: 0;
		font-size: 0.8125rem;
	}
`;

export const ConditionalMenuActions = styled.div`
	padding: 0.25rem;

	button {
		height: 2rem;
		padding-inline: 0.75rem;
		font-size: 0.75rem;
		line-height: 1rem;
	}
`;
